import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  hasPssLengthError(form_group: FormGroup, password_label: string): boolean | undefined {
    return (
      form_group.get(password_label)?.hasError('minlength') && !form_group.get(password_label)?.hasError('required')
    );
  }

  hasPssPatternError(form_group: FormGroup, password_label: string): boolean | undefined {
    return (
      form_group.get(password_label)?.hasError('pattern') &&
      !form_group.get(password_label)?.hasError('minlength') &&
      !form_group.get(password_label)?.hasError('required')
    );
  }

  getPssFormFieldErrorClass(
    form_group: FormGroup,
    password_label: string,
  ): {
    [key: string]: boolean | undefined;
  } {
    return {
      'hmn-form-field__with-error':
        this.hasPssLengthError(form_group, password_label) || this.hasPssPatternError(form_group, password_label),
      '': !this.hasPssLengthError(form_group, password_label) && !this.hasPssPatternError(form_group, password_label),
    };
  }
}
